var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: `sub-group-option-cont${
        !!_vm.SubscriptionGroupData.selected ? " selected" : ""
      }`,
      on: { click: _vm.toggleOption },
    },
    [
      _c("div", [_vm._v(_vm._s(_vm.SubscriptionGroupData.name))]),
      _vm.loading
        ? _c(
            "div",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: 16, width: 2 },
              }),
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    color: !!_vm.SubscriptionGroupData.selected
                      ? "#47BD96FF"
                      : "#FFFFFF26",
                    small: "",
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        !!_vm.SubscriptionGroupData.selected
                          ? "fas fa-check-square"
                          : "far fa-square"
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }